export const apiKeyTypes = {
    acmeware: 'Acmeware Api Client'
};

export const LICENSE_TYPE = Object.freeze({
    SmsMessagingApi: 1,
    EmailMessagingApi: 2,
    ORPortalLicense: 4,
    LayerJotLicense: 5,
    PAMSiteLicense: 6,
    PAMViewerLicense: 7,
    PAMExplorerLicense: 8
});

export const ROLE_IDS = Object.freeze({
    PAM_ADMIN: 40000,
    PAM_USER: 41000,
    STERIS_ADMIN_USER: 20200, 
    STERIS_SUPPORT_ADMIN_USER: 20100, 
    STERIS_SUPPORT_USER: 20000 
});

export const USER_ASSIGNABLE_PAM_LICENSE_TYPE_IDS = Object.freeze([
    LICENSE_TYPE.PAMViewerLicense,
    LICENSE_TYPE.PAMExplorerLicense
]);